<rk-mobile-close-button class="fixed z-10" (click)="exitPanel()"></rk-mobile-close-button>
<ng-container *ngIf="currentRadioId$ | async as radioId">
  <div class="p-5">
    <rk-page-title [title]="'MEDIA.BACS.PICK_BOX' | translate"></rk-page-title>
  </div>
  <div class="section-title" translate>MEDIA.BACS.TITLE_MINE</div>
  <div class="list">
    <ng-container *ngFor="let box of boxes$ | async; let i = index">
      <div
        class="link"
        [class.disabled]="box.id === dataIn.boxId"
        (click)="clickBox(box.id)"
        (touchstart)="onTouch(i)"
        (touchmove)="onTouchEnd()"
        (touchend)="onTouchEnd()"
        [class.touched]="$touched() === i"
      >
        <mat-icon fontSet="fa" [fontIcon]="box.extra['icon']" class="bac-icon"></mat-icon>
        <span>{{ box.translation }}</span>
      </div>
    </ng-container>
  </div>
</ng-container>
